import resume from './resume'
import interview from './interview'
import record from './record'
import apply from './apply'
import collect from './collect'
import message from './message'
import shield from './shield'
import take from './take'
import positionManage from './positionManage'
import company from './company'
import positionDetail from './positionDetail'
import jobFair from './jobFair'
import {api} from '@/http'

// 退出
const logout = (callback, back, error) => {
  api('/api/logout', 'post', '', callback, back, error)
}

// 登入
const login = (data, callback, back, isPhone) => {
  let url = isPhone ? 'phone_login' : 'login'
  api('/api/' + url, 'post', data, callback, back)
}

// 注册
const register = (data, callback, back, error) => {
  api('/api/register', 'post', data, callback, back, error)
}

// 忘记密码
const forgetPassword = (data, callback, back, error) => {
  api('/api/find_password', 'post', data, callback, back, error)
}

// 补充信息
const registerComplete = (data, callback, back, error) => {
  api('/api/register', 'post', data, callback, back, error)
}

// 用户信息
const loginInfo = (callback, back, error) => {
  api('/api/login_info', 'get', '', callback, back, error)
}

// COS临时密钥
const getCosKey = (callback, back, error) => {
  api('/api/temp_obs_key', 'get', '', callback, back, error)
  // api('/api/temp_cos_key', 'get', '', callback, back, error)
}

// 获取字典
const getDictionary = (callback, back) => {
  api('/api/dictionary', 'get', '', callback, back)
}

// 获取区域
const getRegion = (callback, back) => {
  api('/api/region_tree', 'get', '', callback, back)
}

// 获取行业
const getIndustry = (callback, back) => {
  api('/api/industry_tree', 'get', '', callback, back)
}

// 获取专业
const getSpecialty = (callback, back) => {
  api('/api/specialty_tree', 'get', '', callback, back)
}

// 获取职能
const getFunction = (callback, back) => {
  api('/api/function_tree', 'get', '', callback, back)
}

// 获取军人
const getMilitary = (callback, back) => {
  api('/api/soldier_tree', 'get', '', callback, back)
}

// 获取职位
const getPositionTree = (callback, back) => {
  api('/api/position_tree', 'get', '', callback, back)
}

// 修改密码
const passwordUpdate = (data, callback, back) => {
  api('/api/edit_password', 'post', data, callback, back)
}

// 修改用户名
const userNameEdit = (data, callback, back) => {
  api('/api/edit_name', 'post', data, callback, back)
}

// 修改手机号
const userPhoneEdit = (data, callback, back) => {
  api('/api/set_phone', 'post', data, callback, back)
}

// 修改邮箱
const userEmailEdit = (data, callback, back) => {
  api('/api/set_email', 'post', data, callback, back)
}

// 修改身份证
const userIdCardEdit = (data, callback, back) => {
  api('/api/set_id_card_number', 'post', data, callback, back)
}

// 获取参数
const getActiveParam = (callback, back) => {
  api('/api/active_param', 'get', '', callback, back)
}

// 获取验证码
const getCode = (data, callback, back, error) => {
  api('/api/send_sms', 'post', data, callback, back, error)
}

// 获取友情链接
const getFriends = (callback, back) => {
  api('/api/friends', 'get', '', callback, back)
}

// 获取审核状态
const getTaskList = (data, callback, back) => {
  api('/api/interview_feedback', 'get', data, callback, back)
}

// 确认面试反馈
const taskSure = (id, callback, back) => {
  api('/api/interview_feedback/' + id + '/confirm', 'post', '', callback, back)
}

// 获取技能
const getSkill = (callback, back) => {
  api('/api/skill_tree', 'get', '', callback, back)
}

export default {
  login,
  forgetPassword,
  taskSure,
  logout,
  register,
  registerComplete,
  loginInfo,
  getDictionary,
  getIndustry,
  getPositionTree,
  getSpecialty,
  getRegion,
  getCosKey,
  passwordUpdate,
  getActiveParam,
  userNameEdit,
  userIdCardEdit,
  userEmailEdit,
  userPhoneEdit,
  getCode,
  getFunction,
  getMilitary,
  getFriends,
  getTaskList,
  getSkill,
  ...resume,
  ...interview,
  ...record,
  ...apply,
  ...collect,
  ...message,
  ...shield,
  ...take,
  ...positionManage,
  ...company,
  ...positionDetail,
  ...jobFair
}



// WEBPACK FOOTER //
// ./src/api/index.js